<template>
  <div class="scrollbar">
    <loader
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></loader>
    <message
      :message="response_msg"
      :messageType="msg_type"
      v-if="response_msg != ''"
    ></message>
    <div class="col-12 inMiddle-area mt-2">
      <div class="row">
        <div
          class="col-12 space rightFilterSearch"
          v-if="
            dashboardData.length > 0 &&
            dashboardData[0].hasOwnProperty('dashboardData') &&
            dashboardData[0].dashboardData &&
            Object.keys(dashboardData[0].dashboardData).length > 0
          "
        >
          <div class="selectFilter-type d-flex justify-content-between">
            <ul class="tableFilDate d-flex align-items-center">
              <li @click.prevent="" :class="'active'">
                All <sub v-html="tradingAccountList.totalRecords || 0"></sub>
              </li>

              <!-- <li @click.prevent="selectKey = 0; listing()" :class="(selectKey == 0) ? 'active' : ''">All <sub  v-html="(dashboardData[0].dashboardData.total_client != '' && dashboardData[0].dashboardData.total_client != null) ? dashboardData[0].dashboardData.total_client : 0"></sub></li>

                            <li @click.prevent="selectKey = 1; listing()" :class="(selectKey == 1) ? 'active' : ''">Verified <sub  v-html="(dashboardData[0].dashboardData.verified_client != '' && dashboardData[0].dashboardData.verified_client != null) ? dashboardData[0].dashboardData.verified_client : 0"></sub></li>

                            <li @click.prevent="selectKey = 2; listing()" :class="(selectKey == 2) ? 'active' : ''">Unverified <sub v-html="(dashboardData[0].dashboardData.total_client != '' && dashboardData[0].dashboardData.total_client != null) ? (dashboardData[0].dashboardData.total_client - dashboardData[0].dashboardData.verified_client) : 0"></sub></li>

                            <li @click.prevent="selectKey = 3; depositListing()" :class="(selectKey == 3) ? 'active' : ''">Funded <sub  v-html="(dashboardData[0].dashboardData.total_funded != '' && dashboardData[0].dashboardData.total_funded != null) ? dashboardData[0].dashboardData.total_funded : 0"></sub></li>

                            <li @click.prevent="selectKey = 4; listing()" :class="(selectKey == 4) ? 'active' : ''">Closed <sub>---</sub></li> -->
            </ul>
            <app-top-header-title ref="form"></app-top-header-title>
          </div>
        </div>
        <div class="col-12">
          <div class="whiteBG box-shadow">
            <div
              class="tableHead-title d-flex align-items-center justify-content-between mb-2"
            >
              <label class="font-weight-bold"> List</label>
              <div class="rtl d-flex align-items-center">
                <ul class="selectmotr d-flex align-items-center">
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'd' ? 'active' : '']"
                      @click.prevent="eventInterValFl('d', 'stat')"
                      >Day</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'm' ? 'active' : '']"
                      @click.prevent="eventInterValFl('m', 'stat')"
                      >Month</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'y' ? 'active' : '']"
                      @click.prevent="eventInterValFl('y', 'stat')"
                      >Year</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == '' ? 'active' : '']"
                      @click.prevent="eventInterValFl('', 'stat')"
                      >All</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[
                        statInfo.interval == 'custom' ? 'active' : '',
                      ]"
                      @click.prevent="openToggle = !openToggle"
                      >Custom</a
                    >
                    <div class="mainFilterBytime modHalf">
                      <div
                        class="cutDropdown pt-0 px-0 pb-4"
                        :class="openToggle ? 'active' : ''"
                      >
                        <ul class="datPickerT">
                          <li
                            class="headTitle d-flex align-items-center justify-content-between"
                          >
                            <span>Select Date</span>
                          </li>
                          <li class="d-flex align-items-center p-3">
                            <div
                              class="mx-datepicker form-control whiteBG pt-0"
                            >
                              <label>From</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.from"
                                name="dob1"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.from != '' &&
                                  statInfo.from != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div class="mx-datepicker">
                              <label>To</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.to"
                                name="dob2"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.to != '' &&
                                  statInfo.to != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div
                              class="closeIcon"
                              @click.prevent="
                                openToggle = !openToggle;
                                statInfo.from = '';
                              "
                            >
                              <feather type="x"></feather>
                            </div>
                          </li>
                          <li class="px-3 pt-3">
                            <a
                              href="#"
                              @click.prevent="eventInterValFl('custom', 'stat')"
                              class="grd_btn greenBG"
                              >Submit</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
                <!-- <div class="download-table-data ml-3">
                                    <a title="Download Data" @click.prevent="csvExport(tradingAccountList.records,'client_commission','client_commission.csv')"><img src="../../../../static/fxView/images/excel.png" alt="Icon"></a>
                                </div> -->
              </div>
            </div>
            <div class="scrollable-x">
              <table class="table table-striped focus-on clientLst-table">
                <!-- {{ tradingAccountList }} -->
                <thead>
                  <tr>
                    <th>User Name</th>
                    <th>IB User Name</th>
                    <th>Account ID</th>
                    <th>Account Type</th>
                    <th>Currency</th>
                    <th>Leverage</th>
                    <th>Platform</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- ------------{{tradingAccountList}}-------------------- -->
                  <tr
                    v-for="(list, index) in tradingAccountList.records"
                    v-if="
                      tradingAccountList.records.length > 0 &&
                      tradingAccountList.totalRecords > 0
                    "
                  >
                    <td v-html="list.username || '-'"></td>
                    <td v-html="list.ib_username || '-'"></td>
                    <td v-html="list.account_id || '-'"></td>
                    <td v-html="list.account_type || '-'"></td>
                    <td v-html="list.currency || '-'"></td>
                    <td v-html="list.leverage || '-'"></td>
                    <td v-html="list.platform || '-'"></td>
                  </tr>
                  <tr
                    class="noDataFound"
                    v-if="tradingAccountList.totalRecords == 0"
                  >
                    <td colspan="10">
                      <loader
                        :pageloader_value="pageLoader"
                        :type="'table'"
                        :colspan="col_span"
                        :list="tradingAccountList"
                        v-if="pageLoader == false"
                      ></loader>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination
              :getList="tradingAccountList"
              :pageLimit_parent="pageLimit"
              v-if="selectKey != 3 && tradingAccountList.totalRecords > 15"
            ></app-pagination>
            <!-- <app-pagination :getList="depositList" :pageLimit_parent="pageLimit" v-if="selectKey == 3 && depositList.totalRecords > 15"></app-pagination> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "TRADING-ACCOUNTS",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,

      pageLoader: false,
      response_msg: "",
      msg_type: "",
      page: "1",
      col_span: 7,
      filterShow: false,
      disable: false,
      openToggle: false,
      submittedRequest: false,
      statInfo: {
        interval: "",
        from: "",
        to: "",
      },
      search: "",
      pageLimit: 15,
      selectKey: "0",
    };
  },
  methods: {
    maxDate() {
      // return moment().format("YYYY-MM-DD");
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(0,0)
      const dd = String(today.getDate()).padStart(0,0);
      return `${yyyy}-${mm}-${dd}`
    },
    eventInterValFl(interval, eventType) {
      if (eventType == "stat") {
        this.statInfo.interval = interval;
        if (this.statInfo.interval != "custom") {
          this.statInfo.from = this.statInfo.to = "";
          this.listing();
        } else if (
          this.statInfo.interval == "custom" &&
          this.statInfo.from != "" &&
          this.statInfo.to != ""
        ) {
          this.listing();
          //this.openToggle = !this.openToggle
        } else if (this.statInfo.interval == "") {
          this.listing();
        }
      }
    },
    getHumanDate(date) {
      return this.$parent.dateDDMMFormat(date);
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfo.interval,
          stat_from_interval: this.statInfo.from,
          stat_to_interval: this.statInfo.to,
        },
        localParams: { parameter: this },
      };
      // if(this.selectKey == '1'){
      //     inputJson.globalParams.filter['session.verified_status'] = 1
      // }else if(this.selectKey == '2'){
      //     //passed the string for backend condition as 0 != ""
      //     inputJson.globalParams.filter['session.verified_status'] = "0"
      // }else if(this.selectKey == '4'){
      //     inputJson.globalParams.filter['session.verified_status'] = 2
      // }
      this._runGetTradingAccountList(inputJson);
    },
    csvExport(arrData, type, getFileName) {
      /*let csv =  "data:text/csv;charset=utf-8,";
                //console.log("data",arrData)

                const _that =  this
                csv += "Registration Date,Client Name,Email,Country,Sub-Aff. Name,Volume Traded,Total Commission,Sub-Affiliate Comm.,My Comm.,Status \n"
                arrData.forEach(function(row) {
                    let RMname = (_that.get_user.id != row.admin_id && row.RMname != '' && row.RMname != null) ? row.RMname : '-'
                    let status = (row.status == 1) ? 'Active' : 'Inactive'
                     csv += _that.getHumanDate(row.created)+","+row.firstname+","+row.email+","+row.country+","+RMname+","+row.totalVolume+","+row.totalRevenue+","+row.subIbCommission+","+row.myCommission+","+status
                    csv += "\n";
                });
            
                const link = document.createElement('a');
                const data = encodeURI(csv);
                link.setAttribute("href", data);
                link.setAttribute("download", getFileName);
                //console.log("link",link)
                link.click();*/
    },
  },
  created() {
    this.setData(this.pageTitle);
    this.listing();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/trading-accounts/list.vue